import { render, staticRenderFns } from "./BrokersGarantias.vue?vue&type=template&id=0e07c094&scoped=true"
import script from "./BrokersGarantias.vue?vue&type=script&lang=js"
export * from "./BrokersGarantias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e07c094",
  null
  
)

export default component.exports